import { useParams } from 'react-router-dom'

import { ResidentAppError } from '../../../common/error'

export const useCurrentBulletin = () => {
  const { bulletinUuid } = useParams()

  if (!bulletinUuid) {
    throw ResidentAppError.ClientError('NOT_FOUND', {
      message: 'No bulletinUuid found in params',
    })
  }

  return {
    bulletinUuid,
  }
}
